"use client";

import { useTranslation } from "@workspace/i18n";
import { cn } from "@workspace/ui";
import { buttonVariants } from "@workspace/ui-web/button";

import { pathsConfig } from "~/config/paths";
import { authClient } from "~/lib/auth/client";
import { TurboLink } from "~/modules/common/turbo-link";

interface CtaButtonProps
  extends Omit<React.ComponentProps<typeof TurboLink>, "href"> {
  readonly authenticatedText?: string;
  readonly enableAuth?: boolean;
}

const CtaButtonAuthed = ({
  authenticatedText,
  ...props
}: CtaButtonProps) => {
  const { t } = useTranslation(["common", "marketing"]);
  const { data } = authClient.useSession();

  return (
    <TurboLink
      {...props}
      href={
        data?.session
          ? pathsConfig.dashboard.user.index
          : pathsConfig.auth.login
      }
      className={cn(buttonVariants(), props.className)}
    >
      {!data?.session ? t("cta.button") : (authenticatedText ?? t("dashboard"))}
    </TurboLink>
  );
};

export const CtaButton = ({
  authenticatedText,
  enableAuth = true,
  ...props
}: CtaButtonProps) => {
  const { t } = useTranslation(["common", "marketing"]);

  if (!enableAuth) {
    return (
      <TurboLink
        {...props}
        href={pathsConfig.auth.login}
        className={cn(buttonVariants(), props.className)}
      >
        {t("cta.button")}
      </TurboLink>
    );
  }

  return (
    <CtaButtonAuthed authenticatedText={authenticatedText} {...props} />
  );
};
